module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d467b02f9062d098fbee445dc0a58d0a.png";